export default __webpack_public_path__ + "static/media/KOD0041-min.ee3e58ee.webp";